import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum PriorityEnum {
    low = 'low',
    medium = 'medium',
    high = 'high',
    critical = 'critical',
}

export const priorityEnumOptions = enumToOptions(PriorityEnum, 'enum.priority.');
